import axios from '../base/axios';
import API_KEY from './key';

const GET_TVWESTERN = 'flixfrenzy/redux/GET_TVWESTERN';

// eslint-disable-next-line default-param-last
const tvWesternReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVWESTERN:
      return action.payload;
    default:
      return state;
  }
};

export const getTvWestern = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=37`).then((res) => {
    dispatch({
      type: GET_TVWESTERN,
      payload: res.data,
    });
  });
};

export default tvWesternReducer;
